<template>
    <v-container>
        <v-row align="end">
            <v-col cols="12" sm="12" md="4">
                <v-text-field v-model="search" small label="Search" single-line hide-details solo dense flat></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="1">
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn depressed block rounded color="primary" dark v-on="on" > Export </v-btn>
                    </template>
                    <v-list>
                        <v-list-item>
                            <v-list-item-title>Something</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="1">
                <v-btn color="success" block depressed rounded>Add New</v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="2">
                
            </v-col>
        </v-row>
        <content-sheet header="Users">
            <template v-slot:content>
                <v-data-table :loading="loading" :headers="headers" :items="users" :items-per-page="10" loading-text="Loading Users..." :search="search">
                    <template v-slot:item.createdAt="{ item }">
                        {{item.createdAt | moment( "l" ) }}
                    </template>
                    <template v-slot:item.active="{ item }">
                        <v-icon small :color="item.active ? 'green' : 'red'">{{ item.active ? 'fa-check' : 'fa-times'}}</v-icon>
                    </template>
                    <template v-slot:item.firm_id="{ item }">
                        {{ firms[ item.firm_id ].name }}
                    </template>
                    <template v-slot:item.actions="{ item }">

                    </template>
                </v-data-table>
            </template>
        </content-sheet>
    </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'users',
    data: () => ({
        search: '',
        loading: true,
        headers: [
            {
                text: 'First Name',
                align: 'left',
                sortable: true,
                value: 'first_name'
            },
            {
                text: 'Last Name',
                align: 'left',
                sortable: true,
                value: 'last_name'
            },
            {
                text: 'Email',
                align: 'left',
                sortable: true,
                value: 'email'
            },
            {
                text: 'Created',
                align: 'center',
                sortable: true,
                value: 'createdAt'
            },
            {
                text: 'Role',
                align: 'center',
                sortable: true,
                value: 'role'
            },
            {
                text: 'Actions',
                align: 'center',
                sortable: false,
                value: 'actions'
            }
        ]
    }),
    computed: {
        ...mapState({
            users: state => state.users.users_a
        }),
    },
    methods: {
        cancelSubscription(){
            
        },
        enableSubscription(){

        }
    },
    async created(){
        await this.$store.dispatch( 'users/fetchUsers' )
        this.loading = false
    }
}
</script>

<style lang="scss" scoped>

</style>